import React from 'react';
import Menu from './menu';
import imagemLogo from '../../assets/images/sologo.png';

export default props => (
	<aside className="main-sidebar elevation-4 sidebar-light-indigo">
		<a href="../../" className="brand-link navbar-light" style={{ backgroundColor: '#ffffff' }}>
			<img src={imagemLogo} alt="Copyjui Logo" className="brand-image" style={{ marginTop: -3 }} />
			<div style={{ display: 'flex', flexDirection: 'column', marginTop: 0 }}>
				<span className="brand-text" style={{ fontWeight: 'bold', fontSize: 18, color: '#00308A' }}>Compras Copyjui</span>
			</div>
		</a>
		<div className="sidebar">
			<Menu />
		</div>
	</aside>
)
